// Roleplay Data
// Structured for Supabase migration with multi-language support

export const roleplayData = {
  // Roleplay Overview
  overview: {
    id: "roleplay",
    title: {
      tc: "角色扮演",
      sc: "角色扮演",
      en: "Roleplay"
    },
    subtitle: {
      tc: "透過遊戲模式建立課程",
      sc: "通过游戏模式建立课程",
      en: "Create Courses Through Game Mode"
    },
    icon: "gamepad",
    color: "green"
  },

  // Search Section
  searchSection: {
    id: "search_section",
    placeholder: {
      tc: "搜尋單字、片語",
      sc: "搜索单词、短语",
      en: "Search a word, phrase"
    },
    cameraIcon: "📷",
    microphoneIcon: "🎤"
  },

  // Role-Play Lab Section
  roleplayLab: {
    id: "roleplay_lab",
    title: {
      tc: "✦ 角色扮演實驗室 ✦",
      sc: "✦ 角色扮演实验室 ✦",
      en: "✦ Role-Play Lab ✦"
    },
    options: [
      {
        id: "surprise_me",
        title: {
          tc: "驚喜模式",
          sc: "惊喜模式",
          en: "Surprise me"
        },
        icon: "🎁",
        description: {
          tc: "隨機選擇角色扮演情境",
          sc: "随机选择角色扮演情境",
          en: "Random roleplay scenario selection"
        },
        type: "random",
        gradient: "from-red-500 to-pink-600"
      },
      {
        id: "create_my_own",
        title: {
          tc: "創建我的",
          sc: "创建我的",
          en: "Create my own"
        },
        icon: "💬",
        description: {
          tc: "自定義角色扮演情境",
          sc: "自定义角色扮演情境",
          en: "Custom roleplay scenario creation"
        },
        type: "custom",
        gradient: "from-yellow-500 to-orange-600"
      }
    ]
  },

  // Only for you Section
  onlyForYou: {
    id: "only_for_you",
    title: {
      tc: "專為你設計",
      sc: "专为你设计",
      en: "Only for you"
    },
    scenarios: [
      {
        id: "job_interview",
        title: {
          tc: "工作面試",
          sc: "工作面试",
          en: "Job Interview"
        },
        difficulty: {
          tc: "困難",
          sc: "困难",
          en: "HARD"
        },
        difficultyColor: "orange",
        duration: {
          tc: "5-6 分鐘",
          sc: "5-6 分钟",
          en: "5-6 mins"
        },
        icon: "👔",
        description: {
          tc: "工作面試情境練習",
          sc: "工作面试情境练习",
          en: "Job interview scenario practice"
        },
        participants: 2,
        category: "professional"
      },
      {
        id: "bakehouse_conversation",
        title: {
          tc: "麵包店對話",
          sc: "面包店对话",
          en: "Bakehouse conversation"
        },
        difficulty: {
          tc: "簡單",
          sc: "简单",
          en: "EASY"
        },
        difficultyColor: "green",
        duration: {
          tc: "5-6 分鐘",
          sc: "5-6 分钟",
          en: "5-6 mins"
        },
        icon: "🥖",
        description: {
          tc: "麵包店購物對話",
          sc: "面包店购物对话",
          en: "Bakehouse shopping conversation"
        },
        participants: 2,
        category: "daily"
      },
      {
        id: "chat_with_friend",
        title: {
          tc: "與朋友聊天",
          sc: "与朋友聊天",
          en: "Chat with a friend"
        },
        difficulty: {
          tc: "中等",
          sc: "中等",
          en: "MEDIUM"
        },
        difficultyColor: "blue",
        duration: {
          tc: "5-6 分鐘",
          sc: "5-6 分钟",
          en: "5-6 mins"
        },
        icon: "👥",
        description: {
          tc: "朋友間的日常對話",
          sc: "朋友间的日常对话",
          en: "Casual conversation with friends"
        },
        participants: 2,
        category: "social"
      }
    ]
  },

  // Trending now Section
  trendingNow: {
    id: "trending_now",
    title: {
      tc: "熱門推薦",
      sc: "热门推荐",
      en: "Trending now"
    },
    scenarios: [
      {
        id: "coffee_shop",
        title: {
          tc: "咖啡廳點餐",
          sc: "咖啡厅点餐",
          en: "Coffee Shop Ordering"
        },
        difficulty: {
          tc: "簡單",
          sc: "简单",
          en: "EASY"
        },
        difficultyColor: "green",
        duration: {
          tc: "3-4 分鐘",
          sc: "3-4 分钟",
          en: "3-4 mins"
        },
        icon: "☕",
        description: {
          tc: "咖啡廳點餐情境",
          sc: "咖啡厅点餐情境",
          en: "Coffee shop ordering scenario"
        },
        participants: 2,
        category: "daily",
        trending: true
      },
      {
        id: "doctor_appointment",
        title: {
          tc: "醫生預約",
          sc: "医生预约",
          en: "Doctor Appointment"
        },
        difficulty: {
          tc: "中等",
          sc: "中等",
          en: "MEDIUM"
        },
        difficultyColor: "blue",
        duration: {
          tc: "6-7 分鐘",
          sc: "6-7 分钟",
          en: "6-7 mins"
        },
        icon: "🏥",
        description: {
          tc: "醫生預約對話",
          sc: "医生预约对话",
          en: "Doctor appointment conversation"
        },
        participants: 2,
        category: "health",
        trending: true
      },
      {
        id: "shopping_mall",
        title: {
          tc: "購物中心",
          sc: "购物中心",
          en: "Shopping Mall"
        },
        difficulty: {
          tc: "簡單",
          sc: "简单",
          en: "EASY"
        },
        difficultyColor: "green",
        duration: {
          tc: "4-5 分鐘",
          sc: "4-5 分钟",
          en: "4-5 mins"
        },
        icon: "🛍️",
        description: {
          tc: "購物中心購物",
          sc: "购物中心购物",
          en: "Shopping mall experience"
        },
        participants: 2,
        category: "daily",
        trending: true
      }
    ]
  },

  // Bottom Navigation
  bottomNavigation: {
    id: "bottom_navigation",
    tabs: [
      {
        id: "roleplay",
        title: {
          tc: "角色扮演",
          sc: "角色扮演",
          en: "Role-play"
        },
        isActive: true
      },
      {
        id: "courses",
        title: {
          tc: "課程",
          sc: "课程",
          en: "Courses"
        },
        isActive: false
      },
      {
        id: "topics",
        title: {
          tc: "主題",
          sc: "主题",
          en: "Topics"
        },
        isActive: false
      }
    ]
  }
};

// Helper functions for scenario management
export const getScenarioById = (scenarioId) => {
  // Search in all scenario arrays
  const allScenarios = [
    ...roleplayData.onlyForYou.scenarios,
    ...roleplayData.trendingNow.scenarios
  ];
  
  return allScenarios.find(scenario => scenario.id === scenarioId);
};

export const getRandomScenario = () => {
  const allScenarios = [
    ...roleplayData.onlyForYou.scenarios,
    ...roleplayData.trendingNow.scenarios
  ];
  
  if (allScenarios.length === 0) return null;
  
  const randomIndex = Math.floor(Math.random() * allScenarios.length);
  return allScenarios[randomIndex];
};

export const searchScenarios = (query) => {
  const allScenarios = [
    ...roleplayData.onlyForYou.scenarios,
    ...roleplayData.trendingNow.scenarios
  ];
  
  const lowercaseQuery = query.toLowerCase();
  return allScenarios.filter(scenario => 
    scenario.title.en.toLowerCase().includes(lowercaseQuery) ||
    scenario.title.tc.includes(query) ||
    scenario.title.sc.includes(query) ||
    scenario.description.en.toLowerCase().includes(lowercaseQuery)
  );
};
